import { useParams } from "react-router-dom";

export function useOneOnOneAssignmentPdfParamsOrThrow() {
  const {
    level,
    userGroupId,
    oneOnOneLessonType,
    assignmentNumber,
    businessEnglishObjective,
  } = useParams();
  if (!level || !userGroupId || !oneOnOneLessonType || !assignmentNumber) {
    throw new Error(
      "Missing route params: level, userGroupId, oneOnOneLessonType or assignmentNumber",
    );
  }
  return {
    level,
    userGroupId,
    oneOnOneLessonType,
    assignmentNumber: parseInt(assignmentNumber, 10),
    businessEnglishObjective: businessEnglishObjective ?? undefined,
  };
}
